const logging = true

function log(message: any, enableLogging = true): void {
  if (enableLogging) {
    console.log(JSON.parse(JSON.stringify(message)))
  }
}

// TypeScript-friendly debug function
export const debug: (...args: any[]) => void = logging 
  ? console.debug.bind(window.console)
  : () => {}

function warn(message: any, enableLogging = true): void {
  if (enableLogging) {
    console.warn(JSON.parse(JSON.stringify(message)))
  }
}

export { log, warn }
